var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.loading
    ? _c(
        "div",
        { staticClass: "create" },
        [
          _c(
            "b-container",
            { staticClass: "main_layer py-3", attrs: { fluid: "" } },
            [
              _c(
                "b-container",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c(
                          "p",
                          {
                            staticClass:
                              "fs-36 fw-600 white-color my-2 if-tablet",
                          },
                          [
                            _vm._v(" Внесистемная закупка "),
                            _vm.purchase.reg_number
                              ? [_vm._v("№ " + _vm._s(_vm.purchase.reg_number))]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("p", { staticClass: "fs-14 greyBg-color mb-1" }, [
                          _vm._v(
                            "«" +
                              _vm._s(_vm.$store.state.organization.short_name) +
                              "»"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _c("p", { staticClass: "fs-14 greyBg-color" }, [
                          _vm._v(
                            " Пользователь: " +
                              _vm._s(_vm.$store.state.user.full_name) +
                              " "
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-container",
            {
              staticStyle: { "background-color": "#f5f5f7" },
              attrs: { fluid: "" },
            },
            [
              _c(
                "b-container",
                { staticClass: "my-3" },
                [
                  _c("online-course-regular-button", { staticClass: "mb-3" }),
                  _c("text-header", [_vm._v(" Информация о закупке")]),
                  _c("form-row-edit-textarea", {
                    attrs: {
                      rows: 5,
                      label:
                        "Примечание к закупке (отображается только в ЛК Заказчика)",
                    },
                    model: {
                      value: _vm.purchase.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "comment", $$v)
                      },
                      expression: "purchase.comment",
                    },
                  }),
                  _c("form-row-single-select", {
                    attrs: {
                      disabled: !!_vm.purchase.failed_fl44_purchase_id,
                      options: _vm.dictionaries.orderTypes,
                      v: _vm.$v.purchase.order_type_id,
                      label: "Тип закупки",
                      "label-field": "title",
                      placeholder: "Выберите тип закупки",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.orderTypeChanged(true)
                      },
                    },
                    model: {
                      value: _vm.purchase.order_type_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "order_type_id", $$v)
                      },
                      expression: "purchase.order_type_id",
                    },
                  }),
                  !_vm.isBasedOnFailedPurchase &&
                  !_vm.customerCanCreateHiddenPurchase
                    ? _c("form-row-single-select", {
                        attrs: {
                          options: _vm.activeExternalPurchaseCategories,
                          v: _vm.$v.purchase.fl44_external_purchase_category_id,
                          label: "Категория закупки",
                          "label-field": "name",
                          placeholder: "Выберите категорию закупки",
                        },
                        on: {
                          "update:options": function ($event) {
                            _vm.activeExternalPurchaseCategories = $event
                          },
                          input: _vm.handleExternalPurchaseCategoryChange,
                        },
                        model: {
                          value:
                            _vm.purchase.fl44_external_purchase_category_id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.purchase,
                              "fl44_external_purchase_category_id",
                              $$v
                            )
                          },
                          expression:
                            "purchase.fl44_external_purchase_category_id",
                        },
                      })
                    : _vm._e(),
                  _vm.isBasedOnFailedPurchase
                    ? _c("text-row", {
                        attrs: {
                          label: "Номер несостоявшейся закупки",
                          value: _vm.failedPurchaseData?.breadcrumb,
                        },
                      })
                    : _vm._e(),
                  _vm.purchase.failed_fl44_purchase_id &&
                  (!_vm.purchase.deliverable_group_id ||
                    (_vm.purchase.deliverable_group_id &&
                      _vm.$v.purchase.deliverable_group_id.$anyDirty)) &&
                  _vm.purchase.tru_name
                    ? _c("form-row-edit-text", {
                        attrs: {
                          v: _vm.$v.purchase.tru_name,
                          description:
                            'В связи с изменениями в формах создания/редактирования извещений и внесистемных закупок, данное поле более не будет использоваться, пожалуйста, выберите подходящий "Предмет закупки" в поле ниже',
                          disabled: "",
                          label: "Наименование закупки",
                        },
                        model: {
                          value: _vm.purchase.tru_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchase, "tru_name", $$v)
                          },
                          expression: "purchase.tru_name",
                        },
                      })
                    : _vm._e(),
                  _vm.features.kbk_limits &&
                  _vm.currentOrderType?.is_limits_used
                    ? _c("form-row-edit-checkbox", {
                        attrs: {
                          label: "Закупка при отсутствии ЛБО (лимитов по КБК)",
                        },
                        model: {
                          value: _vm.iskbklimitoptional,
                          callback: function ($$v) {
                            _vm.iskbklimitoptional = $$v
                          },
                          expression: "iskbklimitoptional",
                        },
                      })
                    : _vm._e(),
                  _vm.features.kbk_limits && !_vm.iskbklimitoptional
                    ? _c("form-row-edit-checkbox", {
                        attrs: { label: "Авансовый отчет" },
                        model: {
                          value: _vm.purchase.is_advance_report,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchase, "is_advance_report", $$v)
                          },
                          expression: "purchase.is_advance_report",
                        },
                      })
                    : _vm._e(),
                  _vm.currentOrderType?.is_limits_used &&
                  !_vm.iskbklimitoptional
                    ? _c("form-row-single-select", {
                        attrs: {
                          options: _vm.limitYears,
                          label: "Год ПГ (Плана-графика)",
                          "label-field": "id",
                          placeholder: "Выберите год ПГ (Плана-графика)",
                        },
                        on: {
                          input: function ($event) {
                            _vm.purchase.limits.items = []
                          },
                        },
                        model: {
                          value: _vm.purchase.purchase_limit_year,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchase, "purchase_limit_year", $$v)
                          },
                          expression: "purchase.purchase_limit_year",
                        },
                      })
                    : _vm._e(),
                  _c("form-row-single-select", {
                    attrs: {
                      disabled:
                        (!!_vm.purchase.failed_fl44_purchase_id &&
                          _vm.purchase.deliverable_group_id &&
                          !_vm.$v.purchase.deliverable_group_id.$anyDirty) ||
                        !_vm.purchase.fl44_external_purchase_category_id,
                      options: _vm.purchase.failed_fl44_purchase_id
                        ? _vm.dictionaries.purchaseCategories
                        : _vm.activePurchaseCategories,
                      v: _vm.$v.purchase.deliverable_group_id,
                      label: "Предмет закупки",
                      placeholder: "Выберите предмет закупки",
                    },
                    model: {
                      value: _vm.purchase.deliverable_group_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "deliverable_group_id", $$v)
                      },
                      expression: "purchase.deliverable_group_id",
                    },
                  }),
                  _c("form-row-edit-text", {
                    attrs: {
                      disabled:
                        !!_vm.purchase.failed_fl44_purchase_id &&
                        _vm.purchase.purchase_object &&
                        !_vm.$v.purchase.purchase_object.$anyDirty,
                      v: _vm.$v.purchase.purchase_object,
                      hint: "Укажите непосредственно товары, работы, услуги, поставка, выполнение, оказание которых будут являться предметом контракта.",
                      label: "Объект закупки",
                      placeholder: "Введите объект закупки",
                    },
                    model: {
                      value: _vm.purchase.purchase_object,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "purchase_object", $$v)
                      },
                      expression: "purchase.purchase_object",
                    },
                  }),
                  _c("form-row-edit-checkbox", {
                    attrs: {
                      v: _vm.$v.purchase.without_vat,
                      label: "Поставщик освобождён от уплаты НДС",
                      compact: "",
                    },
                    model: {
                      value: _vm.purchase.without_vat,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "without_vat", $$v)
                      },
                      expression: "purchase.without_vat",
                    },
                  }),
                  _c("form-row-specification-table-new", {
                    staticClass: "atmo-hash-jump-point",
                    attrs: {
                      id: "specification",
                      "spec-error-message": _vm.specErrorMessage,
                      "spec-errors": _vm.specErrors,
                      "spec-sum": _vm.specSum,
                      v: _vm.$v.purchase.deliverables,
                      "with-count-edit": !_vm.isBasedOnFailedPurchase,
                      "no-add-spec": _vm.isBasedOnFailedPurchase,
                      "no-delete-spec": _vm.isBasedOnFailedPurchase,
                      "with-vat-edit": "",
                      "without-vat": _vm.purchase.without_vat,
                      "with-price": "",
                    },
                    model: {
                      value: _vm.purchase.deliverables,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "deliverables", $$v)
                      },
                      expression: "purchase.deliverables",
                    },
                  }),
                  _vm.features.kbk_limits && !_vm.iskbklimitoptional
                    ? _c("limits-editable-table", {
                        attrs: {
                          "total-cost": _vm.specSum,
                          "limit-year": _vm.purchase.purchase_limit_year,
                          "order-type": _vm.currentOrderType,
                          "purchase-type": "fl44_external",
                          "purchase-id": _vm.purchaseId,
                        },
                        on: { validate: _vm.limitsValidate },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "info",
                              fn: function () {
                                return [
                                  _c(
                                    "p",
                                    [
                                      _c("b-icon-exclamation-triangle-fill", {
                                        staticClass: "text-warning",
                                      }),
                                      _vm._v(
                                        ' Внимание! Перед добавлением лимитов проверьте правильность значений полей "Год ПГ" и "Тип закупки" в разделе "Информация о закупке". При изменении любого из этих полей все добавленные в таблицу лимиты по КБК будут удалены. '
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3757489672
                        ),
                        model: {
                          value: _vm.purchase.limits.items,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchase.limits, "items", $$v)
                          },
                          expression: "purchase.limits.items",
                        },
                      })
                    : _vm._e(),
                  _c("text-header", [_vm._v("Поставщик")]),
                  _c(
                    "b-row",
                    { staticClass: "py-3" },
                    [
                      _c("b-col", { attrs: { md: "3" } }, [
                        _c("span", { staticClass: "fs-14 grey-color fw-700" }, [
                          _vm._v("Тип поставщика "),
                          _c("span", { staticClass: "red-star" }, [
                            _vm._v("*"),
                          ]),
                        ]),
                      ]),
                      _c(
                        "b-col",
                        { staticClass: "fs-14 grey-color", attrs: { md: "9" } },
                        [
                          _c("b-form-radio-group", {
                            attrs: {
                              disabled: !(
                                !_vm.currentExternalPurchaseCategorySupplierLimited ||
                                _vm.customerCanCreateHiddenPurchase
                              ),
                              options: _vm.providerTypeOptions,
                              stacked: "",
                            },
                            model: {
                              value: _vm.purchase.is_private_provider,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.purchase,
                                  "is_private_provider",
                                  $$v
                                )
                              },
                              expression: "purchase.is_private_provider",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  !_vm.purchase.is_private_provider
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            { staticClass: "py-1" },
                            [
                              _c(
                                "b-col",
                                {
                                  attrs: {
                                    state: !!_vm.selectedProvider,
                                    md: "3",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "fs-14 grey-color fw-700" },
                                    [
                                      _vm._v("Введите ИНН поставщика "),
                                      _c("span", { staticClass: "red-star" }, [
                                        _vm._v("*"),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "b-col",
                                {
                                  staticClass: "fs-14 grey-color",
                                  attrs: { md: "9" },
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "fs-14",
                                    attrs: {
                                      state: !!_vm.selectedProvider,
                                      trim: "",
                                    },
                                    model: {
                                      value: _vm.providerInn,
                                      callback: function ($$v) {
                                        _vm.providerInn = $$v
                                      },
                                      expression: "providerInn",
                                    },
                                  }),
                                  !_vm.selectedProvider
                                    ? _c(
                                        "b-form-invalid-feedback",
                                        { staticClass: "fs-14" },
                                        [_vm._v("Поставщик не выбран")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.foundOrganizationBranches || _vm.providerKpp
                            ? _c(
                                "b-row",
                                { staticClass: "py-1" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        state: !!_vm.selectedProvider,
                                        md: "3",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "fs-14 grey-color fw-700",
                                        },
                                        [
                                          _vm._v("Введите КПП поставщика "),
                                          _c(
                                            "span",
                                            { staticClass: "red-star" },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "fs-14 grey-color",
                                      attrs: { md: "9" },
                                    },
                                    [
                                      _c("b-form-input", {
                                        staticClass: "fs-14",
                                        attrs: {
                                          state: !!_vm.selectedProvider,
                                          trim: "",
                                        },
                                        model: {
                                          value: _vm.providerKpp,
                                          callback: function ($$v) {
                                            _vm.providerKpp = $$v
                                          },
                                          expression: "providerKpp",
                                        },
                                      }),
                                      !_vm.selectedProvider
                                        ? _c(
                                            "b-form-invalid-feedback",
                                            { staticClass: "fs-14" },
                                            [_vm._v("Поставщик не выбран")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "b-row",
                            { staticClass: "py-1 text-right" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "fs-14 grey-color",
                                  attrs: { md: "12" },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "text-uppercase",
                                      attrs: { variant: "custom-green" },
                                      on: { click: _vm.findProvider },
                                    },
                                    [_vm._v("Найти")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.tmpProvider
                            ? _c(
                                "b-row",
                                { staticClass: "py-3" },
                                [
                                  _c("b-col", { attrs: { md: "3" } }),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "fs-14 grey-color",
                                      attrs: { md: "9" },
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        { staticClass: "py-2" },
                                        [
                                          _vm.tmpProvider.id &&
                                          !_vm.tmpProvider.from_dadata
                                            ? _c(
                                                "b-col",
                                                {
                                                  staticClass:
                                                    "fs-14 grey-color fw-700",
                                                  attrs: { md: "12" },
                                                },
                                                [
                                                  _vm._v(
                                                    "Поставщик зарегистрирован в ИС"
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c("text-row", {
                                        attrs: {
                                          compact: "",
                                          label: "ИНН",
                                          value: _vm.tmpProvider.inn,
                                        },
                                      }),
                                      _c("text-row", {
                                        attrs: {
                                          compact: "",
                                          label: "КПП",
                                          value: _vm.tmpProvider.kpp,
                                        },
                                      }),
                                      _c("text-row", {
                                        attrs: {
                                          compact: "",
                                          label: "ОГРН / ОГРНИП",
                                          value: _vm.tmpProvider.ogrn,
                                        },
                                      }),
                                      _c("text-row", {
                                        attrs: {
                                          compact: "",
                                          label: "Наименование",
                                          value: _vm.tmpProvider.full_name,
                                        },
                                      }),
                                      _c("text-row", {
                                        attrs: {
                                          compact: "",
                                          label: "Фактический адрес",
                                          value: _vm.tmpProvider.fact_address,
                                        },
                                      }),
                                      _vm.isForbiddenSupplier
                                        ? _c(
                                            "div",
                                            { staticClass: "text-danger pt-1" },
                                            [
                                              _vm._v(
                                                "Выбор данного поставщика невозможен, так как его предложение было отклонено или он сам отказался заключать контракт"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      !_vm.selectedProvider
                                        ? _c(
                                            "b-button",
                                            {
                                              staticClass: "mt-4",
                                              attrs: {
                                                disabled:
                                                  _vm.isForbiddenSupplier,
                                                variant: "custom-green",
                                              },
                                              on: { click: _vm.selectProvider },
                                            },
                                            [_vm._v("Подтвердить")]
                                          )
                                        : _vm._e(),
                                      !!_vm.selectedProvider
                                        ? _c(
                                            "b-button",
                                            {
                                              staticClass: "mt-4",
                                              attrs: {
                                                disabled: "",
                                                variant: "custom-green",
                                              },
                                            },
                                            [_vm._v("Поставщик выбран")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.selectedProvider &&
                          _vm.selectedProvider.from_dadata
                            ? _c(
                                "b-row",
                                { staticClass: "py-3" },
                                [
                                  _c(
                                    "b-col",
                                    {
                                      attrs: {
                                        state: _vm.newProviderEmailState,
                                        md: "3",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "fs-14 grey-color fw-700",
                                        },
                                        [
                                          _vm._v(
                                            "Введите email для отправки приглашения поставщику "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "red-star" },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "b-col",
                                    {
                                      staticClass: "fs-14 grey-color",
                                      attrs: { md: "9" },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          state: _vm.newProviderEmailState,
                                          trim: "",
                                        },
                                        model: {
                                          value:
                                            _vm.purchase.new_provider.email,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.purchase.new_provider,
                                              "email",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "purchase.new_provider.email",
                                        },
                                      }),
                                      !_vm.newProviderEmailState
                                        ? _c("b-form-invalid-feedback", [
                                            _vm._v("Введите email"),
                                          ])
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("form-row-edit-text", {
                            attrs: {
                              label: "ИНН",
                              v: _vm.$v.purchase.private_provider_data.inn,
                            },
                            model: {
                              value: _vm.purchase.private_provider_data.inn,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.purchase.private_provider_data,
                                  "inn",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "purchase.private_provider_data.inn",
                            },
                          }),
                          _c("form-row-edit-text", {
                            attrs: {
                              label: "ФИО",
                              v: _vm.$v.purchase.private_provider_data.name,
                            },
                            model: {
                              value: _vm.purchase.private_provider_data.name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.purchase.private_provider_data,
                                  "name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "purchase.private_provider_data.name",
                            },
                          }),
                          _c("form-row-edit-address-wo-coordinates", {
                            attrs: {
                              v: _vm.$v.purchase.private_provider_data.address,
                              label: "Адрес регистрации",
                            },
                            model: {
                              value: _vm.purchase.private_provider_data.address,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.purchase.private_provider_data,
                                  "address",
                                  $$v
                                )
                              },
                              expression:
                                "purchase.private_provider_data.address",
                            },
                          }),
                        ],
                        1
                      ),
                  _c("text-header", [
                    _vm._v("Информация о заключенном контракте"),
                  ]),
                  _c("form-row-edit-date", {
                    attrs: {
                      "max-date": _vm.$now(),
                      v: _vm.$v.purchase.contract_conclusion_date,
                      label: "Дата заключения контракта",
                    },
                    model: {
                      value: _vm.purchase.contract_conclusion_date,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "contract_conclusion_date", $$v)
                      },
                      expression: "purchase.contract_conclusion_date",
                    },
                  }),
                  _c("text-row", {
                    attrs: {
                      label: "Статус контракта",
                      value: _vm.statusTitle,
                      hint: "Изменение статуса доступно после сохранения закупки.",
                    },
                  }),
                  _vm.purchase.status === "contract:fulfilled"
                    ? _c("form-row-edit-date", {
                        attrs: {
                          disabled: !_vm.purchase.contract_conclusion_date,
                          "max-date": _vm.$now(),
                          "min-date": _vm.purchase.contract_conclusion_date,
                          v: _vm.$v.purchase.contract_execution_date,
                          label: "Дата исполнения контракта",
                        },
                        model: {
                          value: _vm.purchase.contract_execution_date,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.purchase,
                              "contract_execution_date",
                              $$v
                            )
                          },
                          expression: "purchase.contract_execution_date",
                        },
                      })
                    : _vm._e(),
                  _c("form-row-single-line-document-upload", {
                    attrs: {
                      "label-cols-lg": 3,
                      v: _vm.$v.purchase.contract_attachment,
                      title: "Контракт",
                    },
                    model: {
                      value: _vm.purchase.contract_attachment,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "contract_attachment", $$v)
                      },
                      expression: "purchase.contract_attachment",
                    },
                  }),
                  _c("form-row-edit-text", {
                    attrs: {
                      description: _vm.iskbklimitoptional
                        ? null
                        : _vm.Config.get(
                            "theme.variables.view.customer_contract_number_description"
                          ),
                      v: _vm.$v.purchase.customer_contract_number,
                      label: "Номер контракта в системе учета заказчика",
                    },
                    model: {
                      value: _vm.purchase.customer_contract_number,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "customer_contract_number", $$v)
                      },
                      expression: "purchase.customer_contract_number",
                    },
                  }),
                  _vm.features.kbk_limits &&
                  !_vm.iskbklimitoptional &&
                  !_vm.purchase.is_advance_report
                    ? _c("form-row-edit-supplier-accounting", {
                        on: { validate: _vm.supplierAccountingValidate },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "info",
                              fn: function () {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "Укажите банковские реквизиты поставщика для передачи в РИС."
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          219730525
                        ),
                        model: {
                          value: _vm.purchase.supplier_accounting,
                          callback: function ($$v) {
                            _vm.$set(_vm.purchase, "supplier_accounting", $$v)
                          },
                          expression: "purchase.supplier_accounting",
                        },
                      })
                    : _vm._e(),
                  _c("form-row-upload-multiple-documents", {
                    staticClass: "my-3",
                    attrs: {
                      v: _vm.$v.purchase.execution_documents,
                      title: "Документы об исполнении",
                    },
                    model: {
                      value: _vm.purchase.execution_documents,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchase, "execution_documents", $$v)
                      },
                      expression: "purchase.execution_documents",
                    },
                  }),
                  _vm.specErrors
                    ? _c("p", {
                        staticClass: "text-danger fs-14",
                        domProps: { textContent: _vm._s(_vm.specErrorMessage) },
                      })
                    : _vm._e(),
                  _vm.limitError
                    ? _c("p", {
                        staticClass: "text-danger fs-14",
                        domProps: {
                          textContent: _vm._s(_vm.limitErrorMessage),
                        },
                      })
                    : _vm._e(),
                  _c(
                    "b-row",
                    { staticClass: "my-3 mt-5" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-overlay",
                            {
                              staticClass: "d-inline-block",
                              attrs: {
                                show: _vm.isDataSending,
                                opacity: "0.6",
                                rounded: "",
                                "spinner-small": "",
                                "spinner-variant": "primary",
                              },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-2 text-uppercase",
                                  attrs: {
                                    variant: "custom-outline-secondary",
                                  },
                                  on: { click: _vm.onCancel },
                                },
                                [_vm._v("Отменить")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-overlay",
                            {
                              staticClass: "d-inline-block",
                              attrs: {
                                show: _vm.isDataSending,
                                opacity: "0.6",
                                rounded: "",
                                "spinner-small": "",
                                "spinner-variant": "primary",
                              },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-2 text-uppercase",
                                  attrs: { variant: "custom-danger" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sendData(true)
                                    },
                                  },
                                },
                                [_vm._v("Сохранить черновик")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "b-overlay",
                            {
                              staticClass: "d-inline-block",
                              attrs: {
                                show: _vm.isDataSending,
                                opacity: "0.6",
                                rounded: "",
                                "spinner-small": "",
                                "spinner-variant": "primary",
                              },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "text-uppercase",
                                  attrs: {
                                    disabled: !_vm.isValid,
                                    variant: "custom-green",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sendData(false)
                                    },
                                  },
                                },
                                [_vm._v("Сохранить и опубликовать")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }